import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import SiteNavbar from "@/components/SiteNavbar";
import { Button } from "@/components/ui/button";
import { MapPin, Home, ArrowLeft } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const NotFound = () => {
  const location = useLocation();
  const { t } = useI18n();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SiteNavbar />
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="text-center max-w-md space-y-6">
          <div className="mx-auto h-20 w-20 rounded-2xl bg-primary/10 flex items-center justify-center">
            <MapPin className="h-10 w-10 text-primary" />
          </div>
          <div className="space-y-2">
            <h1 className="text-5xl font-display font-bold text-foreground">404</h1>
            <p className="text-lg text-muted-foreground">
              {t("notFound.title")}
            </p>
            <p className="text-sm text-muted-foreground">
              {t("notFound.description")}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild>
              <Link to="/">
                <Home className="h-4 w-4 mr-2" />
                {t("notFound.home")}
              </Link>
            </Button>
            <Button variant="outline" onClick={() => window.history.back()}>
              <ArrowLeft className="h-4 w-4 mr-2" />
              {t("notFound.back")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
